import moment from 'moment';

export default {
  namespaced: true,
  state: {
    screenType: '',
    screenSize: {},
    villa: null,
    allBookingItemsSorted: [],
    usersBookings: null,
  },
  getters: {
    getScreenType: (state) => state.screenType,
    getScreenSize: (state) => state.screenSize,
    getVilla: (state) => state.villa,
    getBookingItems: (state) => state.allBookingItemsSorted,
    getVillaByID: (state) => (id) => state.allBookingItemsSorted.find((booking) => booking.propertyId === id),
    getUsersBookings: (state) => state.usersBookings,
    isWithinDaysBeforeArrival: (state, getters, rootState, rootGetters) => (days) => {
      if (!state.villa || !state.villa.dateIn) return false;
      // Thinkers (sales-ops viewing as a client) bypass arrival cutoffs.
      if (rootGetters['users/loggedInUser'] && rootGetters['users/loggedInUser'].loggedInAsContactAdmin) return false;
      return moment(state.villa.dateIn).startOf('day').diff(moment().startOf('day'), 'days') < days;
    },
    cutoffDateBeforeArrival: (state) => (days) => {
      if (!state.villa || !state.villa.dateIn) return '';
      return moment(state.villa.dateIn).subtract(days, 'days').format('D MMM YYYY');
    },
  },
  mutations: {
    setScreenType(state, payload) {
      state.screenType = payload;
    },
    setScreenSize(state, payload) {
      state.screenSize = payload;
    },
    setVilla(state, payload) {
      state.villa = payload;
    },
    setBookingItems(state, payload) {
      state.allBookingItemsSorted = payload;
    },
    setVillaByID(state, commit, id) {
      const villa = state.allBookingItemsSorted.find((booking) => booking.propertyId === id);
      commit('setVillaID', villa);
    },
    setUsersBookings(state, payload) {
      state.usersBookings = payload;
    },
  },
};
